'use client';
import React from 'react';
import useTimer from '@lib/hooks/useTimer';
import { AnalyticsEvent, sendEvent } from '@utils/segment';

type TemplatesPageWrapperProps = {
  slug: string;
  category?: string;
  children: React.ReactNode;
};

// This component is primarily used for tracking user enngagement

export default function TemplatesPageWrapper({ slug, category, children }: TemplatesPageWrapperProps) {
  useTimer((time: number) => {
    const secondsOnPage = Math.round(time / 1000);
    const hash = slug.split('-')[0];

    sendEvent(AnalyticsEvent.TemplateViewed, {
      secondsOnPage,
      slug,
      hash,
      category,
    });
  });

  return children;
}
